import { useState } from 'react';

interface UseMultiSelectOptions<T> {
  value: number[];
  options: T[];
  onChange: (val: number[]) => void;
  maxItems: number;
  getId: (item: T) => number;
}

export function useMultiSelect<T>({
  value,
  options,
  onChange,
  maxItems,
  getId,
}: UseMultiSelectOptions<T>) {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOptions = options.filter((item) => {
    const itemId = getId(item);

    return value.includes(itemId);
  });

  const handleSelectionChange = (vals: string[]) => {
    onChange(vals.map(Number));
  };

  const handleRemoveItem = (itemId: number) => {
    onChange(value.filter((id) => id !== itemId));
  };

  const isItemDisabled = (item: T) => {
    const itemId = getId(item);

    return value.length >= maxItems && !value.includes(itemId);
  };

  return {
    isOpen,
    setIsOpen,
    selectedOptions,
    handleSelectionChange,
    handleRemoveItem,
    isItemDisabled,
  };
}
